const state = {
    packageInformationFields: [
        {
            key: "item_title",
            label: "",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "qty",
            label: "數量(PCS)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "total_weight",
            label: "重量(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "item_title_2",
            label: "",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "name",
            label: "名稱",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "count",
            label: "支數(PCS)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "piece",
            label: "應包件數",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "weight",
            label: "盒重/箱重(KG)",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "package_qty",
            label: "即時包裝數量",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "package_box_qty",
            label: "即時包裝盒/箱數",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
    ],
    packageInformationItem: [
    ],
}
const getters = {
    get_packageInformationFields: state => {
        return state.packageInformationFields
    },
    get_packageInformationItem: state => {
        return state.packageInformationItem
    },
}
const actions = {
    set_packageInformationFields(context, array) {
        context.commit('SET_PACKAGEINFORMATIONFIELDS', array);
    },
    set_packageInformationItem(context, array) {
        context.commit('SET_PACKAGEINFORMATIONITEM', array);
    },
    clear_packageInformationItem(context) {
        context.commit('CLEAR_PACKAGEINFORMATIONITEM');
    },
}
const mutations = {
    SET_PACKAGEINFORMATIONFIELDS(state, array) {
        state.packageInformationFields = array;
    },
    SET_PACKAGEINFORMATIONITEM(state, array) {
        state.packageInformationItem = array;
    },
    CLEAR_PACKAGEINFORMATIONITEM(state) {
        state.packageInformationItem = [];
    },    
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/packageInformation.js